import type { WidgetDefinition, WidgetRegistry, WidgetType } from '../types';

import { dashboardLinksWidget } from './dashboard-links';
import { deviceWidget } from './device';
import { devicesWidget } from './devices';
import { histogramWidget } from './histogram';
import { lineGraphWidget } from './line-graph';
import { queryValueWidget } from './query-value';
import { sceneWidget } from './scene';
import { scenesWidget } from './scenes';
import { utilitiesHistogramWidget } from './utilities-histogram';
import { utilitiesStatWidget } from './utilities-stat';

/**
 * Registry of all available widget types
 */
export const widgetRegistry: WidgetRegistry = {
  'query-value': queryValueWidget,
  'dashboard-links': dashboardLinksWidget,
  'line-graph': lineGraphWidget,
  histogram: histogramWidget,
  scene: sceneWidget,
  scenes: scenesWidget,
  device: deviceWidget,
  devices: devicesWidget,
  'utilities-stat': utilitiesStatWidget,
  'utilities-histogram': utilitiesHistogramWidget,
};

/**
 * Get a widget definition by type
 */
export function getWidgetDefinition(type: WidgetType): WidgetDefinition | undefined {
  return widgetRegistry[type];
}

/**
 * Get all widget types
 */
export function getWidgetTypes(): WidgetType[] {
  return Object.keys(widgetRegistry) as WidgetType[];
}

/**
 * Check if a type is a valid widget type
 */
export function isValidWidgetType(type: string): type is WidgetType {
  return type in widgetRegistry;
}

/**
 * Get all widget definitions for the widget picker
 */
export function getAllWidgetDefinitions(): WidgetDefinition[] {
  return Object.values(widgetRegistry);
}
